import { render } from "./infoModal.vue?vue&type=template&id=ab5245a6&ts=true"
import script from "./infoModal.vue?vue&type=script&lang=ts"
export * from "./infoModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__